import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { evaluationService } from '../services/evaluationService';
import AppSidebar from '../components/AppSidebar';
import AddressMap from '../components/Maps/AddressMap';
import AddressAutocomplete from '../components/AddressAutocomplete';
import toast from 'react-hot-toast';
import { getLimitErrorMessage } from '../utils/limitErrorMessages';
import '../App.css';

const EvaluateAddress: React.FC = () => {
  const navigate = useNavigate();
  const [headerAddress, setHeaderAddress] = useState<string>('');

  const handleEvaluateFromHeader = async (overrideAddress?: string) => {
    const addressToUse = (overrideAddress ?? headerAddress).trim();
    if (!addressToUse) {
      toast.error('Please enter an address');
      return;
    }
    try {
      const newEvaluation = await evaluationService.evaluateAddress(
        addressToUse,
        'single_family',
      );
      toast.success('Evaluation started!');
      navigate(`/evaluation/${newEvaluation._id}`);
    } catch (error: any) {
      toast.error(getLimitErrorMessage(error, 'Failed to evaluate address'));
    }
  };

  const defaultAddress = {
    fullAddress: 'United States',
  };

  return (
    <div className="wti-shell">
      <AppSidebar />

      <div className="wti-main">
        <header className="wti-header">
          <div className="wti-header-left">
            <div className="wti-search-row">
              <div style={{ width: '65%' }}>
                <AddressAutocomplete
                  value={headerAddress}
                  onChange={(val) => setHeaderAddress(val)}
                  onAddressSelect={(addr, place) => {
                    setHeaderAddress(addr);
                    handleEvaluateFromHeader(addr);
                  }}
                  placeholder="Search US address only"
                />
              </div>
            </div>
          </div>
          <div className="wti-header-right" />
        </header>

        <main className="wti-content">
          <section className="wti-map-column">
            <AddressMap address={defaultAddress as any} neighborhoodTractCode={undefined} />
          </section>
          <section className="wti-right-column">
            <div
              style={{
                textAlign: 'center',
                maxWidth: 520,
                alignSelf: 'center',
                marginTop: 40,
              }}
            >
              <h2 style={{ margin: '0 0 12px', fontSize: 38, fontWeight: 600 }}>
                Address Evaluator
              </h2>
              <p style={{ margin: 0, color: '#6b7280', fontSize: 20 }}>
                Unlock your neighborhood&apos;s S.E.C.R.R.E.T.S
              </p>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default EvaluateAddress;

